<div
  class="flex flex-col rounded-(--detailexpandablecard-border-radius) gap-(--detailexpandablecard-gap) px-(--detailexpandablecard-padding-x) py-(--detailexpandablecard-padding-y) w-full"
  [style.background]="containerBackground()"
>
  @if (isCollapsible()) {
    <app-dynamic
      componentName="DynamicText"
      [props]="titleProps()"
    />
  }

  @if (!isCollapsible() || isExpanded()) {
    <div
      class="text-(--detailexpandablecard-content-color)"
      [innerHTML]="sanitizedContent()"
    ></div>
  }

  @if (isCollapsible()) {
    <div class="self-start">
      <app-dynamic
        componentName="Button"
        [props]="buttonProps()"
        (action)="toggle()"
      />
    </div>
  }
</div>
